export default __webpack_public_path__ + "static/media/solution-sharifcamp.9926895a.jpg";